import React from "react";

import Chip from "@material-ui/core/Chip";

const cellStyle = {
  backgroundColor: "rgba(0, 0, 143, 0.75)",
  color: "#fff"
};

function skillExcelCell(options, column, gridCell) {
  let row = gridCell.data;
  let prefix = column.dataField;
  let cisField = prefix + "_cis";
  let typeNameField = prefix + "_typeName";
  let nameField = prefix + "_name";
  if (row[prefix]) {
    options.value = (row[cisField] || "") + "  " + (row[typeNameField] || "") + "  " + (row[nameField] || "");
  }
}

function skillCell(config, columnSpec) {
  let prefix = columnSpec.dataField;
  let cisField = prefix + "_cis";
  let nameField = prefix + "_name";
  let typeNameField = prefix + "_typeName";
  config.cellRender = SkillCell;
  config.dataType = "string";
  config.alignment = "center";
  config.calculateCellValue = (row) => {
    if (row[prefix]) {
      return (row[cisField] ? row[cisField] + " | " : "") +
             (row[typeNameField] ? row[typeNameField] + " | " : "") + (row[nameField] || "");
    } else {
      return null;
    }
  }
}

const SkillCell = (cellData) => {
  if (cellData.value) {
    return (<div><Chip style={cellStyle} label={cellData.value}/></div>);
  }
  return null;
};


export {skillCell, skillExcelCell}
